// Set to false to silence all order notifications
export const ORDER_SOUND_ENABLED = true;

export function playOrderSound(orderCount) {
  if (!ORDER_SOUND_ENABLED) return;

  const ctx = new (window.AudioContext || window.webkitAudioContext)();
  ctx.resume();

  // Reverb
  const conv = ctx.createConvolver();
  const len = Math.floor(ctx.sampleRate * 0.9);
  const rb = ctx.createBuffer(2, len, ctx.sampleRate);
  for (let ch = 0; ch < 2; ch++) {
    const d = rb.getChannelData(ch);
    for (let i = 0; i < len; i++)
      d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 2.2);
  }
  conv.buffer = rb;
  const wetG = ctx.createGain(); wetG.gain.value = 0.30;
  const master = ctx.createGain(); master.gain.value = 0.60;
  conv.connect(wetG); wetG.connect(ctx.destination);
  master.connect(ctx.destination); master.connect(conv);

  const t = ctx.currentTime;

  function sq(freq, t0, dur, amp, cutoff) {
    const o = ctx.createOscillator(), f = ctx.createBiquadFilter(), g = ctx.createGain();
    o.type = 'square'; o.frequency.value = freq;
    f.type = 'lowpass'; f.frequency.value = cutoff; f.Q.value = 2.2;
    g.gain.setValueAtTime(amp, t0);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
    o.connect(f); f.connect(g); g.connect(master);
    o.start(t0); o.stop(t0 + dur + 0.08);
  }

  function sine(freq, t0, dur, amp, cutoff) {
    const o = ctx.createOscillator(), f = ctx.createBiquadFilter(), g = ctx.createGain();
    o.type = 'sine'; o.frequency.value = freq;
    f.type = 'lowpass'; f.frequency.value = cutoff;
    g.gain.setValueAtTime(amp, t0);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
    o.connect(f); f.connect(g); g.connect(master);
    o.start(t0); o.stop(t0 + dur + 0.08);
  }

  function click(freq, t0, amp) {
    const o = ctx.createOscillator(), g = ctx.createGain();
    o.type = 'square'; o.frequency.value = freq;
    g.gain.setValueAtTime(amp, t0);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.018);
    o.connect(g); g.connect(master);
    o.start(t0); o.stop(t0 + 0.025);
  }

  // Sweep intro
  const sw = ctx.createOscillator(), swg = ctx.createGain();
  sw.type = 'sine';
  sw.frequency.setValueAtTime(440, t);
  sw.frequency.exponentialRampToValueAtTime(440 * Math.min(orderCount, 4), t + 0.12);
  swg.gain.setValueAtTime(0.22, t);
  swg.gain.exponentialRampToValueAtTime(0.0001, t + 0.13);
  sw.connect(swg); swg.connect(master);
  sw.start(t); sw.stop(t + 0.15);

  // D minor stap — D4 F4 A4 D5
  const notes  = [293.66, 349.23, 440.00, 587.33];
  const num    = Math.min(orderCount + 1, 4);
  const step   = orderCount === 1 ? 0 : 0.17;
  const offset = 0.10;

  for (let i = 0; i < num; i++) {
    const freq = notes[i];
    const last = i === num - 1;
    const t0   = t + offset + i * step;
    const dur  = last ? 0.70 : 0.16;
    const amp  = last ? 0.34 : 0.24;

    sq(freq,          t0, dur,        amp,        last ? 700 : 520);
    sine(freq * 0.5,  t0, dur + 0.12, amp * 0.55, 220);
    sine(freq * 0.25, t0, dur + 0.22, amp * 0.28, 110);
    click(freq * 2.5, t0, amp * 0.55);

    if (last) sq(freq * 2, t0 + 0.07, dur * 0.55, amp * 0.15, 1000);
  }

  // 3+ orders: diepe D3 + radar ping
  if (orderCount >= 3) {
    const ft = t + offset + (num - 1) * step + 0.32;
    sine(146.83 * 0.5,  ft, 0.55, 0.35, 200);
    sine(146.83 * 0.25, ft, 0.65, 0.20, 110);

    const pt = t + offset + (num - 1) * step + 0.50;
    const po = ctx.createOscillator(), pg = ctx.createGain();
    po.type = 'sine'; po.frequency.value = 1200;
    pg.gain.setValueAtTime(0.25, pt);
    pg.gain.exponentialRampToValueAtTime(0.0001, pt + 0.35);
    po.connect(pg); pg.connect(master);
    po.start(pt); po.stop(pt + 0.40);
  }

  // Elke melding een eigen AudioContext: na afloop sluiten, anders blijft er
  // per nieuwe order eentje (met audio-thread) open staan zolang de app draait.
  // Langste klank ≈ 1,7 s plus 0,9 s galm.
  setTimeout(() => ctx.close().catch(() => {}), 3000);
}
